export default "__VITE_ASSET__DghC7fjr__"